
import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import {
  DeviceByDeviceKeyBulkGetRequest,
  HomingDetailsWithDeviceAssetDataResponse,
  DeviceByMakeAndSerialBulkGetRequest,
  DeviceByMakeSerialAndDeviceCharBulkGetRequest
} from '../entities/homing-v2/models';
import { axiosInstance } from "../axios-instance";

class Homing {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getDeviceByDeviceKey(
    deviceKey: string,
  ): Promise<AxiosResponse<HomingDetailsWithDeviceAssetDataResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<HomingDetailsWithDeviceAssetDataResponse>(
      `${this.baseUrl}/devices/deviceKeys/${deviceKey}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }

  bulkGetDevicesByDeviceKeys(
    input: Array<DeviceByDeviceKeyBulkGetRequest>,
  ): Promise<AxiosResponse<Array<HomingDetailsWithDeviceAssetDataResponse>>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<Array<HomingDetailsWithDeviceAssetDataResponse>>(
      `${this.baseUrl}/devices/bulkGetByDeviceKey`,
      input,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }


bulkGetAssetMakeAndSerailNumber(
  input: Array<DeviceByMakeAndSerialBulkGetRequest>,
): Promise<AxiosResponse<Array<HomingDetailsWithDeviceAssetDataResponse>>> {
  const accessToken = localStorage.getItem('accessToken');
  return axiosInstance.post<Array<HomingDetailsWithDeviceAssetDataResponse>>(
    `${this.baseUrl}/bulkGetByAssetMakeAndSerialNumber`,
    input,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
}

bulkGetAssetMakeSerailNumberAndDeviceChar(
  input: Array<DeviceByMakeSerialAndDeviceCharBulkGetRequest>,
): Promise<AxiosResponse<Array<HomingDetailsWithDeviceAssetDataResponse>>> {
  const accessToken = localStorage.getItem('accessToken');
  return axiosInstance.post<Array<HomingDetailsWithDeviceAssetDataResponse>>(
    `${this.baseUrl}/bulkGetByAssetMakeAndSerialNumberAndDeviceCharacterization`,
    input,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
}

}

export default Homing;
